module.exports = __webpack_public_path__ + "static/preview-6-43dcfe179e0fce2d1919da30fa1df450.png";